import styled from 'styled-components';
import { caption, colors, utilityColors, spacing, fonts, fontWeights } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Badge } from 'ui/badge';
import { Positioner } from 'ui/inputs/InputStyles';
import { AccordionContent } from '../AccordionContent';
import { ErrorTypes } from '../types';

export const ErrorLabel = styled.div`
  align-items: center;
  color: ${colors.textSecondary};
  display: grid;
  flex: 1 0 auto;
  font-family: ${fonts.sansSerif};
  gap: ${spacing.half};
  grid-template-columns: max-content auto max-content;
  margin-right: ${spacing.half};
  white-space: nowrap;
`;

export const Bold = styled.span`
  color: ${colors.textPrimary};
  font-weight: ${fontWeights.semiBold};
`;

export const StyledAccordionContent = styled(AccordionContent)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const StyledBadge = styled(Badge)`
  background: ${colors.salmon10};
  justify-self: end;
  &[data-type=${ErrorTypes.Warning}] {
    color: ${utilityColors.warning100};
  }
  &[data-type=${ErrorTypes.Error}] {
    color: ${utilityColors.negative100};
  }
`;

export const StyledContainer = styled.div`
  padding-bottom: 0;
`;

export const StyledPositioner = styled(Positioner)`
  column-gap: ${spacing.quarter};
  flex-direction: row;
`;

export const StyledSubMessage = styled.div`
  ${caption};
  color: ${colors.secondaryText};
  padding-left: ${pxToRem(21)};
`;

export const StyledBannerMessage = styled.span`
  font-weight: ${fontWeights.semiBold};
  &[data-type=${ErrorTypes.Warning}] {
    color: ${utilityColors.warning100};
  }
  &[data-type=${ErrorTypes.Error}] {
    color: ${utilityColors.negative100};
  }
`;
